import React, { useContext/*, useState*/ } from "react";
import { AppContext } from "../Provider/Provider";


const CategoriaCard = ({ name, getCateName, currentCateName }) => {
  const [valoresConsumoState, setValoresConsumoState] = useContext(AppContext);

  var localkWh1 = 0;
  var localkWh2
  var localCant = 0;

  
  localkWh1 = valoresConsumoState["ValoresCategoriaCard"][name].kWh;
  
  localkWh2 = localkWh1.toFixed(2); // Lo muestra con 2 decimales
  
  localCant = valoresConsumoState["ValoresCategoriaCard"][name].Cant;
  
  
  function handleOnclick() {
    getCateName(name);
  }
  

  return (
    <> {name.localeCompare(currentCateName) == 0 
        ? <div
            className={"group bg-gray-100 border-2 border-green-600 | p-2 rounded-md h-full w-full | shadow-lg | cursor-pointer"}
            onClick={() => handleOnclick()}
          >
            <div className={"flex flex-col justify-center text-center md:text-left"}>
              {name.localeCompare("Electrónica, Audio y Video") == 0
                ? <div> 
                      <p className={"text-green-600 text-sm font-semibold uppercase hidden md:inline"}>
                        {name}
                      </p>
                      <p className={"text-green-600 text-xs font-semibold uppercase  md:hidden"}>
                        Elect. Audio y Video
                      </p>
                  </div>
                : <p className={"text-green-600 text-sm font-semibold uppercase"}>
                      {name}
                  </p>
              }
              <p className={"text-green-600 text-sm font-bold mt-2"}>
                {localkWh2} kWh
              </p>
              <p className={"text-green-600 text-justify text-xs font-base | md:block"}>
                {localCant} Electrodomésticos
              </p>
            </div>
          </div>
        : <div className={`group bg-gray-100 border-2 border-gray-100 | p-2 rounded-md h-full w-full | 
                            shadow-md | cursor-pointer hover:shadow-lg`}
            onClick={() => handleOnclick()}
          >
        <div className={"flex flex-col justify-center text-center md:text-left"}>
          {name.localeCompare("Electrónica, Audio y Video") == 0
            ? <div>
                <p className={"text-gray-400 text-sm font-semibold uppercase hidden md:inline"}>
                  {name}
                </p>
                <p className={"text-gray-400 text-xs font-semibold uppercase md:hidden"}>
                  Elect. Audio y Video
                </p>
              </div> 
            : <p className={"text-gray-400 text-sm font-semibold uppercase"}>
                {name}
              </p> 
          }
          <p className={"text-gray-400 text-sm font-bold mt-2"}>
            {localkWh2} kWh
          </p>
          <p className={"text-gray-400 text-justify text-xs font-base | md:block"}>
            {localCant} Electrodomésticos
          </p>
        </div>
      </div>
      }
    </>
  );
};

export default CategoriaCard